export const initEmojiLib = async () => {
  const { init } = await import(/* webpackPreload: true */ 'emoji-mart')
  const data = await import(/* webpackPreload: true */ '@emoji-mart/data')
  init({ data })
}
